import { MedicalRecordForm } from 'models/MedicalRecord/MedicalRecordForm.type'

import {
  DIAGNOSTIC_STATUS_LABELS,
  MEDICATION_STATUS_LABELS,
} from './fieldLabels'

export const formatMedicationsList = (form: MedicalRecordForm): string[] => {
  const meds = form.medications?.map((m) => {
    const name = m.medication?.commercial_name ?? m.medication?.generic_name ?? ''
    const statusLabel = MEDICATION_STATUS_LABELS[m.status] ?? m.status
    return statusLabel ? `${name}, ${statusLabel}` : name
  }) ?? []

  const others = form.other_medications?.map((om) => {
    const name = om.commercial_name ?? ''
    const statusLabel = MEDICATION_STATUS_LABELS[om.status] ?? om.status
    return statusLabel ? `${name}, ${statusLabel}` : name
  }) ?? []

  return [...meds, ...others].filter((item) => item && item.trim() !== '')
}

export const formatDiagnosticsList = (form: MedicalRecordForm): string[] => {
  if (!form.diagnostic_hypotheses?.length) return []
  return form.diagnostic_hypotheses
    .map((d) => {
      const description = d.diagnostic_hypothesis?.description ?? ''
      const statusLabel = DIAGNOSTIC_STATUS_LABELS[d.status] ?? d.status
      return statusLabel ? `${description}, ${statusLabel}` : description
    })
    .filter((item) => item && item.trim() !== '')
}
